import { ioExtend } from '@framework';
import { UserModel } from './users.model';

export class GuestModel extends UserModel {
    UserID = null;
    Password = null;
    OldPassword = null;

    constructor(_guest: {}) {
        super(_guest);
        ioExtend(this, _guest);
    }

    toJSONData() {
        return JSON.stringify(this);
    }
}

export class AuthModel {

    AuthToken: string = null;
    AuthSalt: string = null;
    isPassExpired: string = null;

}

